namespace $.$$ {

	const { rem } = $mol_style_unit

	$mol_style_define( $eve_button_inline, {
		display: 'inline-flex',
		verticalAlign: 'baseline',
		padding: rem(0),
		borderRadius: rem( 0.25 ),
		minHeight: 0,
	} )

}
